module.exports = __webpack_public_path__ + "img/download.579c68c5.svg";